import { useGsapAnimations } from "./animations/gsap";

function themeJs() {
  console.log("OCPSA Theme Loaded");

  // Load animations
  useGsapAnimations();
}

document.addEventListener("DOMContentLoaded", themeJs);
